import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user';
import menus from './modules/menus'
import companyInfo from './modules/companyInfo'
Vue.use(Vuex)

export default new Vuex.Store({
  namespaced: true,
  modules: {
    user,
    menus,
    companyInfo
  }
})
